module.exports = __webpack_public_path__ + "static/media/top_right_v10.7d648000.png";